<template>
  <div class="header-options">
    <div v-for="group in groups" v-bind:key="group.label">
      <labelc type="groupheader bold" :text="group.label" />
      <labelc
        v-for="item in group.items"
        :disabled="item.disabled"
        v-bind:key="item.text"
        type="block border-bottom"
        :text="item.text"
        :icon-left="item.icon != undefined ? { icon: item.icon } : null"
        @click="ItemClicked(item)"
      />
    </div>
    <labelc
      v-for="item in items"
      :disabled="item.disabled"
      v-bind:key="item.text"
      type="block border-bottom"
      :text="item.text"
      :icon-left="
        item.icon != undefined
          ? { icon: item.icon, styleIcon: item.styleIcon }
          : null
      "
      @click="ItemClicked(item)"
    />
  </div>
</template>

<script>
export default {
  name: "burgermenu",
  data() {
    return {
      pictureUrl: "",
      name: "",
      groups: [],
      items: [],
    };
  },
  computed: {},
  watch: {
    state: {
      immediate: true,
      handler(newVal, oldVal) {
        for (let x in newVal) this[x] = newVal[x];
      },
    },
  },
  props: {
    state: Object,
  },
  methods: {
    ItemClicked(item) {
      if (item.click != undefined) {
        item.click();
      }
      if (item.closeOnClick) {
        this.Close();
      }
    },
    Close() {
      this.$parent.Toggle();
    },
  },
};
</script>

<style scoped>
.header-options {
  width: 280px;
}
</style>
